<div class="automation-style admin-automation-col">
  <h2 class="heading">{{'Automated Targeting Engine Test'|translate}}</h2>
  <br>
    <span>{{'Session Files'|translate}}:</span>&nbsp;&nbsp;
    <select name="record" id="record" (change)="updateRecord($event)" [(ngModel)]="noOfRecords">
        <option value="20" selected="selected">20</option>
        <option value="100">100</option>&nbsp;
        <option value="500">500</option>
        <option value="1000" disabled>1000</option>
    </select>&nbsp;&nbsp;
    <span><button  (click)="getRecords()" class="btn-style">{{'Submit'|translate}}</button></span>
    <br>
    <div *ngIf="progressbar && !afterTest" class="progress">
        <div class="progress-bar progress-bar-striped s"></div>
      </div>
      <div *ngIf="progressbar && !afterTest">
        {{'Performing Test'|translate}}..
      </div>
      <br>
<div *ngIf="!progressbar && afterTest">
    <div style="display: block; " >
        <canvas baseChart 
          [height]="300"
          [width]="450"
          [datasets]="barChartData"
          [labels]="barChartLabels"
          [options]="barChartOptions"
          [plugins]="barChartPlugins"
          [legend]="barChartLegend"
          [chartType]="barChartType"
          [colors]="chartColors"
         >
        </canvas>
      </div> 
     <!-- <table><tbody>
         <tr>
             <td>
                <table><tbody>
                    <tr>{{'Total'|translate}}:</tr>
                    <tr>Passed:</tr>
                    <tr>Failed:</tr>
                </tbody></table>
             </td>
         
            <td>
               <table><tbody>
                   <tr>{{reportData.totalRecords}}</tr>
                   <tr>{{reportData.passed}}</tr>
                   <tr>{{reportData.failed}}</tr>
               </tbody></table>
            </td>
        </tr>
     </tbody></table> -->
     <br>
     <div>{{'Details'|translate}}:</div>

<div style="display: block;margin-left:50px">
    <div class="system" *ngFor="let g of details; index as i">

      <div *ngIf="showArray[i]">
        <span *ngIf="g.result=='PASSED'"  class="imgspan"><img title="Click to close" class="s9" src="assets/images/admin-minus.gif" (click)="onSelectgroup(i)" alt="-">Session file {{i + 1}}</span>
        <span *ngIf="g.result=='FAILED'" class="imgspan"><img title="Click to close" class="s9" src="assets/images/admin-minus-fail.gif" (click)="onSelectgroup(i)" alt="-">Session file {{i + 1}}</span>
        <span *ngIf="g.result=='INVALID SESSION:MISSING VEHICLE MODEL' || g.result=='INVALID SESSION:MISSING SYMPTOMS'" class="imgspan"><img title="Click to close" class="s9" src="assets/images/admin-minus-invalid.gif" (click)="onSelectgroup(i)" alt="-">Session file {{i + 1}}</span>
        <div >{{ g | json}}</div>
      </div>
      <div *ngIf="!showArray[i]">
        <span *ngIf="g.result=='PASSED'"  class="imgspan"><img title="Click to expand" class="s9" src="assets/images/admin-plus.gif"  (click)="onSelectgroup1(i)" alt="-">Session file {{i + 1}}</span>
        <span *ngIf="g.result=='FAILED'" class="imgspan"><img title="Click to expand" class="s9" src="assets/images/admin-plus-fail.gif"  (click)="onSelectgroup1(i)" alt="-">Session file {{i + 1}}</span>
        <span *ngIf="g.result=='INVALID SESSION:MISSING VEHICLE MODEL' || g.result=='INVALID SESSION:MISSING SYMPTOMS'" class="imgspan"><img title="Click to expand" class="s9" src="assets/images/admin-plus-invalid.gif"  (click)="onSelectgroup1(i)" alt="-">Session file {{i + 1}}</span>
        <div></div>
      </div></div></div>
</div></div>